import { render, staticRenderFns } from "./IncomeCertification.vue?vue&type=template&id=4e85882a&"
import script from "./IncomeCertification.vue?vue&type=script&lang=js&"
export * from "./IncomeCertification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports